import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'
import { authMiddleware } from 'redux-implicit-oauth2'
import { createStore, applyMiddleware } from 'redux'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
import reducers from '../ducks'
import initialState from '../state'

function reduxStore() {
  const store = createStore(
    reducers,
    initialState,
    applyMiddleware(
      thunkMiddleware,
      createLogger(),
      authMiddleware,
      routerMiddleware(browserHistory),
    ),
    window.devToolsExtension && window.devToolsExtension()
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../ducks', () => {
      // We need to require for hot reloadign to work properly.
      const nextReducer = require('../ducks');  // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store
}

export default reduxStore;



// WEBPACK FOOTER //
// ./stores/index.js